/* ver 1.4 */
import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader";

export function AssetLoader(unify) {
  // --------------------------
  // To Load
  const loadGltfURLs = [];
  const gltfNames = [];
  const loadFbxURLs = [];
  const fbxNames = [];
  const loadTextureURLs = [];
  const textureNames = [];
  const loadAudioURLs = [];
  const audioNames = [];
  let dupeFlag = false;
  let oldName = "";
  // --------------------------
  // Asset Storage
  unify.addNewAsset("models", {});
  unify.addNewAsset("textures", {});
  unify.addNewAsset("audioBuffers", {});

  const log = (name, path) => {
    if (unify.debugMode) console.log("AssetLoader: Queued " + name + " | " + path);
  };

  // test path and name
  const validateInput = (path, name, nameArray) => {
    if (typeof path === "string") {
      let checkedName = checkForDupes(name || unify.utilities.nameFromPath(path), nameArray);
      log(checkedName, path);
      return checkedName;
    } else {
      console.error("AssetLoader: Path not valid");
      return null;
    }
  };

  // check for duplicate name
  const checkForDupes = (name, nameArray) => {
    if (nameArray.includes(name)) {
      if (!dupeFlag) {
        oldName = name;
        dupeFlag = true;
      }
      let newName = unify.utilities.incrementString(name);
      checkForDupes(newName, nameArray);
    } else {
      if (dupeFlag) {
        console.warn("AssetLoader: Duplicate name - " + oldName + " renamed to: " + name);
        dupeFlag = false;
      }
      return name;
    }
  };

  // ----------------------------------------------------------------------------
  // GLTF
  // ----------------------------------------------------------------------------
  this.loadGLTF = (path, name) => {
    name = validateInput(path, name, gltfNames);
    if (name != null) {
      gltfNames.push(name);
      loadGltfURLs.push(path);
    }
  };
  // ----------------------------------------------------------------------------
  // FBX
  // ----------------------------------------------------------------------------
  this.loadFBX = (path, name) => {
    name = validateInput(path, name, gltfNames);
    if (name != null) {
      fbxNames.push(name);
      loadFbxURLs.push(path);
    }
  };
  // ----------------------------------------------------------------------------
  // Textures
  // ----------------------------------------------------------------------------
  this.loadTexture = (path, name) => {
    name = validateInput(path, name, gltfNames);
    if (name != null) {
      textureNames.push(name);
      loadTextureURLs.push(path);
    }
  };
  // ----------------------------------------------------------------------------
  // Audio
  // ----------------------------------------------------------------------------
  this.loadAudio = (path, name) => {
    name = validateInput(path, name, gltfNames);
    if (name != null) {
      audioNames.push(name);
      loadAudioURLs.push(path);
    }
  };
  // ------------------------------------------
  // Load called by engine
  // ------------------------------------------
  this.load = manager => {
    // ------------------------------------------
    // Loaders
    // ------------------------------------------
    let gltfLoader;
    let fbxLoader;
    let textureLoader;
    let audioLoader;

    if (loadGltfURLs.length > 0) gltfLoader = new GLTFLoader(manager);
    if (loadFbxURLs.length > 0) fbxLoader = new FBXLoader(manager);
    if (loadTextureURLs.length > 0) textureLoader = new THREE.TextureLoader(manager);
    if (loadAudioURLs.length > 0) audioLoader = new THREE.AudioLoader(manager);

    // GLTF foreach
    loadGltfURLs.forEach(function(url, i) {
      gltfLoader.load(url, function(gltf) {
        unify.assets.models[gltfNames[i]] = gltf;
      });
    });
    // FBX foreach
    loadFbxURLs.forEach(function(url, i) {
      fbxLoader.load(url, function(fbx) {
        unify.assets.models[fbxNames[i]] = fbx;
        //if (fbx.hasOwnProperty("animations")) main.assets.animations[fbxNames[i]] = fbx.animations;
      });
    });
    // Textures foreach
    loadTextureURLs.forEach(function(url, i) {
      textureLoader.load(url, function(texture) {
        unify.assets.textures[textureNames[i]] = texture;
      });
    });
    // Audio foreach
    loadAudioURLs.forEach(function(url, i) {
      audioLoader.load(url, function(buffer) {
        unify.assets.audioBuffers[audioNames[i]] = buffer;
      });
    });
  };

  this.start = () => {
    if (unify.debugMode) {
      console.log("MAIN.ASSETS contains (next line) -> ");
      console.log(unify.assets);
      console.log("MAIN.SCENE objects (next line) -> ");
      console.log(unify.scene.children);
    }
  };
}
